import { render, staticRenderFns } from "./MailProcessingTemplateForm.vue?vue&type=template&id=5200a2cf"
import script from "./MailProcessingTemplateForm.vue?vue&type=script&lang=js"
export * from "./MailProcessingTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports